import { createSelector } from 'reselect';

const stateSelector = state => state.liability;

export const isLiabilityPaidSelector = createSelector(
  stateSelector,
  ({ liabilityStatus }) =>
    liabilityStatus && liabilityStatus.traffic_light === 'GREEN'
);
